/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-02-28 13:48:49
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/mdtIndicatorsGroup/searchMdtIndicatorsGroupList`
  return http.post(url, data)
}

// 获取所有区域--指标概览
export function getAllJiGou(data){
  const url = `/mdtIndicatorsGroup/getGroupConditions`
  return http.post(url,data)
}

// 获取所有批次--指标概览
export function getAllPiCi(data){
  const url = `/mdtIndicatorsGroup/getSeedlingConditions`
  return http.post(url,data)
}

// 获取所有品种--指标概览
export function getAllPinZhong(data){
  const url = `/mdtIndicatorsGroup/getBreedConditions`
  return http.post(url,data)
}
